import { useState, useEffect, useCallback } from 'react';
import api from '../api';
import * as XLSX from 'xlsx';
import StrategyUnitTable from '../components/StrategyUnitTable';
import StrategyFactTable from '../components/StrategyFactTable';
import SeasonStats from '../components/SeasonStats';
import SeasonCalc from '../components/SeasonCalc';

const fmt = (v, dec=0) => v == null || isNaN(v) ? '—' : Number(v).toLocaleString('ru-RU', { maximumFractionDigits: dec });

// ═══ СОЗДАНИЕ ═══
function CreateModal({ articles, onCreated, onCancel }) {
  const [name, setName] = useState('');
  const [nmId, setNmId] = useState('');
  const [seasonDays, setSeasonDays] = useState(60);
  const [seasonStart, setSeasonStart] = useState(new Date().toISOString().split('T')[0]);
  const [saving, setSaving] = useState(false);
  const inp = {background:'rgba(0,0,0,0.3)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:8,color:'#fff',fontSize:12,padding:'8px 10px',outline:'none',width:'100%',boxSizing:'border-box'};
  const save = async () => {
    setSaving(true);
    try {
      const art = articles.find(a=>String(a.nm_id)===String(nmId));
      const r = await api.post('/strategies', {name:name||(art?.vendor_code?art.vendor_code+' — стратегия':'Новая стратегия'),nm_id:nmId||null,vendor_code:art?.vendor_code||'',season_days:seasonDays,season_start:seasonStart});
      onCreated(r.data);
    } catch(e) { console.error(e); }
    setSaving(false);
  };
  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.8)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={e=>e.target===e.currentTarget&&onCancel()}>
      <div style={{background:'#111827',border:'1px solid rgba(255,255,255,0.1)',borderRadius:16,padding:28,width:500}}>
        <div style={{fontSize:16,fontWeight:700,marginBottom:20}}>+ Новая стратегия</div>
        <div style={{marginBottom:12}}>
          <div style={{fontSize:11,color:'rgba(200,215,235,0.5)',marginBottom:5}}>Название</div>
          <input value={name} onChange={e=>setName(e.target.value)} placeholder="Например: Кроссовки осень 2026" style={inp}/>
        </div>
        <div style={{marginBottom:12}}>
          <div style={{fontSize:11,color:'rgba(200,215,235,0.5)',marginBottom:5}}>Артикул (необязательно)</div>
          <select value={nmId} onChange={e=>setNmId(e.target.value)} style={inp}>
            <option value=''>— Без артикула, всё вручную —</option>
            {articles.map(a=><option key={a.nm_id} value={a.nm_id}>{a.vendor_code}</option>)}
          </select>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:20}}>
          <div>
            <div style={{fontSize:11,color:'rgba(200,215,235,0.5)',marginBottom:5}}>Начало сезона</div>
            <input type="date" value={seasonStart} onChange={e=>setSeasonStart(e.target.value)} style={inp}/>
          </div>
          <div>
            <div style={{fontSize:11,color:'rgba(200,215,235,0.5)',marginBottom:5}}>Длина сезона, дней</div>
            <input type="number" value={seasonDays} onChange={e=>setSeasonDays(Number(e.target.value))} style={inp}/>
          </div>
        </div>
        <div style={{display:'flex',gap:10}}>
          <button onClick={save} disabled={saving} style={{flex:1,background:'rgba(59,130,246,0.25)',border:'1px solid rgba(59,130,246,0.5)',color:'#60a5fa',fontSize:13,padding:'10px',borderRadius:8,cursor:'pointer',fontWeight:700}}>{saving?'Создаём...':'Создать стратегию'}</button>
          <button onClick={onCancel} style={{background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',color:'rgba(200,215,235,0.5)',fontSize:13,padding:'10px 20px',borderRadius:8,cursor:'pointer'}}>Отмена</button>
        </div>
      </div>
    </div>
  );
}

// ═══ СПИСОК ═══
function StrategyList({ strategies, onOpen, onDelete, onNew }) {
  if (strategies.length === 0) return (
    <div style={{textAlign:'center',padding:80,color:'rgba(200,215,235,0.3)'}}>
      <div style={{fontSize:48,marginBottom:16}}>◎</div>
      <div style={{fontSize:15,marginBottom:8,color:'rgba(200,215,235,0.5)'}}>Нет стратегий</div>
      <div style={{fontSize:12,marginBottom:24}}>Создайте первую стратегию чтобы начать расчёт окупаемости</div>
      <button onClick={onNew} style={{background:'rgba(59,130,246,0.2)',border:'1px solid rgba(59,130,246,0.4)',color:'#60a5fa',fontSize:13,padding:'10px 24px',borderRadius:8,cursor:'pointer',fontWeight:700}}>+ Новая стратегия</button>
    </div>
  );
  return (
    <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))',gap:14}}>
      {strategies.map(s=>(
        <div key={s.id} onClick={()=>onOpen(s.id)} style={{background:'#111827',border:'1px solid rgba(255,255,255,0.08)',borderRadius:14,padding:18,cursor:'pointer'}}
          onMouseEnter={e=>e.currentTarget.style.border='1px solid rgba(59,130,246,0.35)'}
          onMouseLeave={e=>e.currentTarget.style.border='1px solid rgba(255,255,255,0.08)'}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:12}}>
            <div>
              <div style={{fontSize:14,fontWeight:700,color:'#fff',marginBottom:2}}>{s.name}</div>
              {s.vendor_code&&<div style={{fontSize:10,color:'rgba(200,215,235,0.4)'}}>{s.vendor_code} · <span className="blur-nmid">{s.nm_id}</span></div>}
            </div>
            <button onClick={e=>{e.stopPropagation();if(window.confirm('Удалить?'))onDelete(s.id);}} style={{background:'none',border:'none',color:'rgba(239,68,68,0.4)',cursor:'pointer',fontSize:16,padding:4}}>🗑</button>
          </div>
          <div style={{fontSize:10,color:'rgba(200,215,235,0.3)'}}>
            Начало: {new Date(s.season_start).toLocaleDateString('ru-RU')} · Сезон: {s.season_days} дн · {s.status==='active'?'🟢 Активна':s.status==='done'?'✅ Завершена':'📝 Черновик'}
          </div>
        </div>
      ))}
    </div>
  );
}


// ═══ БЛОК СЦЕНАРИЕВ ═══
function parseVoronkaFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const XLSX = require('xlsx');
        const wb = XLSX.read(e.target.result, {type:'array'});
        const ws = wb.Sheets['Товары'];
        if (!ws) return reject('Нет листа Товары');
        const data = XLSX.utils.sheet_to_json(ws, {header:1});
        const headers = data[1];
        const row = data[2];
        if (!row) return reject('Нет данных');
        const get = (name) => { const idx = headers.indexOf(name); return idx>=0?row[idx]:null; };
        const wsInfo = wb.Sheets['Общая информация'];
        let days = 92;
        if (wsInfo) {
          const info = XLSX.utils.sheet_to_json(wsInfo, {header:1});
          const match = info[1]?.[1] && String(info[1][1]).match(/(\d{4}-\d{2}-\d{2}).*?(\d{4}-\d{2}-\d{2})/);
          if (match) days = Math.round((new Date(match[2])-new Date(match[1]))/86400000)+1;
        }
        resolve({
          shows: Math.round((get('Показы')||0)/days),
          ctr: get('CTR')||8,
          convCart: get('Конверсия в корзину, %')||8,
          convOrder: get('Конверсия в заказ, %')||25,
          buyout: get('Процент выкупа')||34,
          days,
        });
      } catch(e) { reject(e.message); }
    };
    reader.readAsArrayBuffer(file);
  });
}

function ScenarioBlock({ plan, seasonDays=60, onScenariosChange }) {
  const SCEN_DEFAULTS = {
    worst: { shows:'', ctr:8, convCart:8, convOrder:25, buyout:34, drr:15, label:'Худший', hint:'конец сезона', color:'#ef4444' },
    base:  { shows:'', ctr:8, convCart:8, convOrder:25, buyout:34, drr:10, label:'Базовый', hint:'от начала роста до начала спада сезона', color:'#60a5fa' },
    best:  { shows:'', ctr:8, convCart:8, convOrder:25, buyout:34, drr:5,  label:'Лучший', hint:'период лучших конверсий в сезоне', color:'#10b981' },
  };
  const savedScenarios = plan.scenarios || {};
  const [scenarios, setScenarios] = useState({
    worst: { ...SCEN_DEFAULTS.worst, ...(savedScenarios.worst||{}) },
    base:  { ...SCEN_DEFAULTS.base,  ...(savedScenarios.base||{})  },
    best:  { ...SCEN_DEFAULTS.best,  ...(savedScenarios.best||{})  },
  });
const [loading, setLoading] = useState({worst:false, base:false, best:false});
  const [stock, setStock] = useState((plan.scenarios&&plan.scenarios.__stock)||0);
  const [riskPct, setRiskPct] = useState((plan.scenarios&&plan.scenarios.__riskPct)||40);


  // Маржа с РК из юнитки
  const cells = plan.cells || {};
  const params = plan.params || {};
  const price = Number(cells['Цена до СПП|#0d1526']||0);
  const spp = Number(params.spp||35);
  const priceSpp = Math.round(price*(1-spp/100)*100)/100;
  const cost = Number(cells['Себес.|#1a1208']||0);
  const ff = Number(cells['ФФ|#1a1208']||params.ff||100);
  const itogSeb = cost+ff;
  const vol = cells['Объём (л)|#130f1a'];
  const volN = Number(vol)||0;
  const calcLogBaseS = (v) => {
    if (!v||v<=0) return 0;
    const vn = Number(v);
    if (vn>1) return Math.round((Number(params.logBase||46)+(vn-1)*Number(params.logExtra||14))*10)/10;
    if (vn<=0.2) return 23; if (vn<=0.4) return 26; if (vn<=0.6) return 29; if (vn<=0.8) return 30;
    return 32;
  };
  const logBase = Number(cells['Логистика база|#130f1a']||calcLogBaseS(vol)||0);
  const vozvrat = Number(cells['Стоимость возврата|#0b1220']||logBase);
  const buyoutPct = Number(cells['Процент выкупа|#130f1a']||30);
  const il = Number(params.coef1||1.04);
  const koef = Number(params.coefSklad||1.45);
  const irp = price>0 ? Math.round(params.irp*price/100*100)/100 : 0;
  const deliv = logBase*koef*il+irp;
  const itogLog = buyoutPct>0 ? Math.round(((100-buyoutPct)*(vozvrat+deliv)/buyoutPct+deliv)*100)/100 : 0;
  const baseH = Number(params.storageBase||0.08);
  const extraH = Number(params.storageExtra||0.08);
  const sumDayAuto = volN>0 ? (volN>1 ? Math.round((baseH+(volN-1)*extraH)*1000)/1000 : Math.round(baseH*1000)/1000) : 0;
  const storDay = Number(cells['Сумма на 1 ед. (в день)|#0b1220']||sumDayAuto||0);
  const itogHran = Math.round(storDay*Number(params.turnover||120)*100)/100;
  const commPct = Number(cells['Комиссия на 1 ед.|#1a0d0d']||params.commission||36);
  const itogComm = price>0 ? Math.round(price*commPct/100*100)/100 : 0;
  const taxPct = Number(cells['% Налога|#160b0b']||params.tax||6);
  const itogTax = priceSpp>0 ? Math.round(priceSpp*taxPct/100*100)/100 : 0;
  const drrVal = Math.round(price*Number(params.drr||5)/100*100)/100;
  const marginRK = price>0 ? Math.round((price-itogSeb-itogLog-itogHran-itogComm-itogTax-drrVal)*100)/100 : 0;

  // Маржа без РК (из юнитки)
  const marginNoRK = price>0 ? Math.round((price-itogSeb-itogLog-itogHran-itogComm-itogTax)*100)/100 : 0;

  const calcScen = (s) => {
    const shows = Number(s.shows)||0;
    if (!shows) return null;
    // Считаем маржу с учётом ДРР этого сценария
    const drrOnOrder = Math.round(priceSpp*Number(s.drr||10)/100*100)/100;
    const scenBuyout = Number(cells['Процент выкупа|#130f1a']||s.buyout||30);
    const scenDrrVal = scenBuyout>0 ? Math.round(drrOnOrder/(scenBuyout/100)*100)/100 : 0;
    const scenMargin = price>0 ? Math.round((marginNoRK-scenDrrVal)*100)/100 : 0;
    if (!scenMargin) return null;
    const transitions = Math.round(shows * s.ctr/100 * 10)/10;
    const baskets = Math.round(transitions * s.convCart/100 * 10)/10;
    const orders = Math.round(baskets * s.convOrder/100 * 10)/10;
    const sales = Math.round(orders * s.buyout/100 * 10)/10;
    const marginDay = Math.round(sales * scenMargin * 100)/100;
    const stockN = Number(stock)||0;
    const daysToSell = sales>0 && stockN>0 ? Math.ceil(stockN/sales) : null;
    const activeDays = daysToSell ? Math.min(seasonDays, daysToSell) : seasonDays;
    const profitSeason = Math.round(marginDay * activeDays);
    const stockWarning = daysToSell && daysToSell < seasonDays ? `Товар закончится через ${daysToSell} дн — на ${seasonDays-daysToSell} дн раньше сезона. Рассмотри дозакупку.` : null;
    return { transitions, baskets, orders, sales, marginDay, profitSeason, scenMargin, activeDays, daysToSell, stockWarning };
  };

  const loadFile = async (key, file) => {
    setLoading(l=>({...l,[key]:true}));
    try {
      // XLSX already imported statically
      const buf = await file.arrayBuffer();
      const wb = XLSX.read(buf, {type:'array'});
      const ws = wb.Sheets['Товары'];
      if (!ws) { alert('Нет листа Товары'); return; }
      const data = XLSX.utils.sheet_to_json(ws, {header:1});
      const headers = data[1];
      const row = data[2];
      if (!row) { alert('Нет данных'); return; }
      const get = (name) => { const idx = headers.indexOf(name); return idx>=0?Number(row[idx])||0:0; };
      const wsInfo = wb.Sheets['Общая информация'];
      let days = 92;
      if (wsInfo) {
        const info = XLSX.utils.sheet_to_json(wsInfo, {header:1});
        const str = info[1]?.[1] ? String(info[1][1]) : '';
        const match = str.match(/(\d{4}-\d{2}-\d{2}).*?(\d{4}-\d{2}-\d{2})/);
        if (match) days = Math.round((new Date(match[2])-new Date(match[1]))/86400000)+1;
      }
      setScenarios(prev => {
        const next = {...prev, [key]: {
          ...prev[key],
          shows: Math.round(get('Показы')/days),
          ctr: get('CTR')||8,
          convCart: get('Конверсия в корзину, %')||8,
          convOrder: get('Конверсия в заказ, %')||25,
          buyout: get('Процент выкупа')||34,
        }};
        if(onScenariosChange) onScenariosChange(next);
        return next;
      });
    } catch(e) { alert('Ошибка: '+e.message); }
    setLoading(l=>({...l,[key]:false}));
  };

  const fmt = (v,d=0) => v==null||isNaN(v)?'—':Number(v).toLocaleString('ru-RU',{maximumFractionDigits:d});
  const fmtP = (v) => v==null?'—':Number(v).toFixed(1)+'%';
  const inp = {background:'rgba(0,0,0,0.3)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:6,color:'#fff',fontSize:11,padding:'4px 8px',outline:'none',width:'100%',boxSizing:'border-box'};

  const results = {
    worst: calcScen(scenarios.worst),
    base:  calcScen(scenarios.base),
    best:  calcScen(scenarios.best),
  };

  const baseProfit = results.base?.profitSeason || 0;
  const stopLoss = baseProfit > 0 ? Math.round(baseProfit * riskPct / 100) : 0;
  const baseBudget = baseProfit > 0 ? Math.round(baseProfit * 0.35) : 0;
  const netProfit = baseProfit > 0 ? baseProfit - baseBudget : 0;
  const gap = results.best && results.worst ? results.best.profitSeason - results.worst.profitSeason : 0;
  const worstWarning = results.worst && results.worst.profitSeason < 0 ? `При худшем сценарии продажи убыточны ${results.worst.profitSeason.toLocaleString('ru-RU')} ₽. Раздачи только увеличат потери.` : null;

  return (
    <div style={{marginTop:16,background:'#0a0f1a',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20}}>
      <div style={{fontSize:13,fontWeight:700,color:'#f59e0b',marginBottom:16}}>📈 Сценарии на сезон</div>


      {/* Остаток */}
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16,background:'rgba(255,255,255,0.03)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:10,padding:'10px 16px'}}>
        <span style={{fontSize:11,color:'rgba(200,215,235,0.5)',whiteSpace:'nowrap'}}>Остаток на складе, шт:</span>
        <input type="number" value={stock||''} onChange={e=>{const v=Number(e.target.value);setStock(v);if(onScenariosChange){if(window._stockSaveTimer)clearTimeout(window._stockSaveTimer);window._stockSaveTimer=setTimeout(()=>onScenariosChange({...scenarios,__stock:v}),800);}}}
          style={{width:100,background:'rgba(0,0,0,0.3)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:6,color:'#fff',fontSize:13,fontWeight:700,padding:'5px 10px',outline:'none'}}/>
        <span style={{fontSize:10,color:'rgba(200,215,235,0.3)'}}>Используется для расчёта дней до распродажи в каждом сценарии</span>
      </div>

      {/* Три колонки загрузки + параметры */}
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12,marginBottom:20}}>
        {Object.entries(scenarios).map(([key,s])=>{
          const res = results[key];
          return (
            <div key={key} style={{background:'rgba(255,255,255,0.03)',border:'1px solid '+s.color+'33',borderRadius:10,padding:14}}>
              <div style={{fontSize:12,fontWeight:700,color:s.color,marginBottom:4}}>{key==='worst'?'😰':key==='base'?'📊':'🚀'} {s.label}</div><div style={{fontSize:9,color:'rgba(200,215,235,0.35)',marginBottom:10}}>{s.hint}</div>

              {/* Переключатель файл/вручную */}
              <div style={{display:'flex',gap:6,marginBottom:10}}>
                <button onClick={()=>setScenarios(prev=>({...prev,[key]:{...prev[key],inputMode:'file'}}))}
                  style={{flex:1,background:(!s.inputMode||s.inputMode==='file')?'rgba(59,130,246,0.2)':'rgba(255,255,255,0.03)',border:'1px solid '+(!s.inputMode||s.inputMode==='file'?'rgba(59,130,246,0.4)':'rgba(255,255,255,0.08)'),color:(!s.inputMode||s.inputMode==='file')?'#60a5fa':'rgba(200,215,235,0.4)',fontSize:10,padding:'5px',borderRadius:6,cursor:'pointer'}}>
                  📁 Файл
                </button>
                <button onClick={()=>setScenarios(prev=>({...prev,[key]:{...prev[key],inputMode:'manual'}}))}
                  style={{flex:1,background:s.inputMode==='manual'?'rgba(139,92,246,0.2)':'rgba(255,255,255,0.03)',border:'1px solid '+(s.inputMode==='manual'?'rgba(139,92,246,0.4)':'rgba(255,255,255,0.08)'),color:s.inputMode==='manual'?'#a78bfa':'rgba(200,215,235,0.4)',fontSize:10,padding:'5px',borderRadius:6,cursor:'pointer'}}>
                  ✏️ Вручную
                </button>
              </div>
              {(!s.inputMode||s.inputMode==='file') && (
                <label style={{display:'block',background:'rgba(255,255,255,0.05)',border:'1px dashed rgba(255,255,255,0.15)',borderRadius:7,padding:'8px',textAlign:'center',cursor:'pointer',marginBottom:10,fontSize:10,color:'rgba(200,215,235,0.5)'}}>
                  {loading[key]?'Загружаем...':(s.shows?'📁 Файл загружен':'📁 Загрузить файл воронки')}
                  <input type="file" accept=".xlsx" style={{display:'none'}} onChange={e=>e.target.files[0]&&loadFile(key,e.target.files[0])}/>
                </label>
              )}

              {/* Редактируемые поля */}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:6,marginBottom:10}}>
                {[
                  {l:'Показы/день',k:'shows',hint:'Из файла воронки за выбранный период'},
                  {l:'CTR %',k:'ctr',hint:'Меняй если поменял главное фото'},
                  {l:'Конв.→корзина %',k:'convCart',hint:'Меняй если улучшил карточку внутри'},
                  {l:'Конв.→заказ %',k:'convOrder',hint:'Меняй если поменял цену или добавил отзывы'},
                  {l:'Выкуп %',k:'buyout',hint:'Меняй если улучшил описание размерной сетки'},
                  {l:'ДРР %',k:'drr',hint:'Худший=15%, Базовый=10%, Лучший=5%'},
                ].map(f=>(
                  <div key={f.k}>
                    <div style={{fontSize:9,color:'rgba(200,215,235,0.4)',marginBottom:2}} title={f.hint}>{f.l} ?</div>
                    <input type="number" value={s[f.k]||''} onChange={e=>setScenarios(prev=>{const next={...prev,[key]:{...prev[key],[f.k]:e.target.value}};if(onScenariosChange){if(window._scenarioSaveTimer)clearTimeout(window._scenarioSaveTimer);window._scenarioSaveTimer=setTimeout(()=>onScenariosChange(next),800);}return next;})} style={inp}/>
                  </div>
                ))}
              </div>

              {/* Результат */}
              {res && (
                <div style={{borderTop:'1px solid rgba(255,255,255,0.06)',paddingTop:8,fontSize:10}}>
                  {[
                    ['Переходов/день', fmt(res.transitions,1)],
                    ['Корзин/день',    fmt(res.baskets,1)],
                    ['Заказов/день',   fmt(res.orders,1)],
                    ['Выкупов/день',   fmt(res.sales,1)],
                    ['Маржа/шт',       fmt(res.scenMargin)+' ₽'],
                    ['Маржа/день',     fmt(res.marginDay)+' ₽'],
                    ['Активных дней',  fmt(res.activeDays)+' дн'],
                    ['Прибыль за сезон', fmt(res.profitSeason)+' ₽'],
                  ].map(([l,v])=>(
                    <div key={l} style={{display:'flex',justifyContent:'space-between',marginBottom:3}}>
                      <span style={{color:'rgba(200,215,235,0.4)'}}>{l}</span>
                      <span style={{color:s.color,fontWeight:600}}>{v}</span>
                    </div>
                  ))}
                </div>
              )}
              {res?.stockWarning && (
                <div style={{marginTop:8,padding:'6px 10px',background:'rgba(245,158,11,0.1)',border:'1px solid rgba(245,158,11,0.3)',borderRadius:7,fontSize:10,color:'#f59e0b'}}>
                  ⚠️ {res.stockWarning}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Итог */}
      {(results.worst||results.base||results.best) && (
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr',gap:10,marginTop:4}}>
          {worstWarning && (
            <div style={{gridColumn:'1/-1',padding:'8px 14px',background:'rgba(239,68,68,0.08)',border:'1px solid rgba(239,68,68,0.25)',borderRadius:8,fontSize:11,color:'#ef4444'}}>
              ⚠️ {worstWarning}
            </div>
          )}
          {[
            {l:'Стоп-лосс ('+riskPct+'% от базы)', v:fmt(stopLoss)+' ₽', c:'#ef4444', hint:'Максимум на раздачи — столько можешь потерять без банкротства'},
            {l:'Рекомендуемый бюджет',  v:fmt(baseBudget)+' ₽', c:'#f59e0b', hint:'35% от базового сценария'},
            {l:'Прогноз чистой прибыли',v:fmt(netProfit)+' ₽',  c:'#10b981', hint:'База минус рекомендуемый бюджет'},
            {l:'Разрыв лучший/худший',  v:fmt(gap)+' ₽',        c:'#8b5cf6', hint:'Цена риска — насколько критичны раздачи'},
          ].map(c=>(
            <div key={c.l} title={c.hint} style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(255,255,255,0.06)',borderRadius:10,padding:'12px 14px'}}>
              <div style={{fontSize:9,color:'rgba(200,215,235,0.4)',marginBottom:4}}>{c.l}</div>
              <div style={{fontSize:16,fontWeight:700,color:c.c}}>{c.v}</div>
            </div>
          ))}
          <div style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(255,255,255,0.06)',borderRadius:10,padding:'12px 14px',display:'flex',alignItems:'center',gap:8}}>
            <div style={{fontSize:9,color:'rgba(200,215,235,0.4)',whiteSpace:'nowrap'}}>% риска:</div>
            <input type="number" value={riskPct} onChange={e=>{const v=Number(e.target.value);setRiskPct(v);if(onScenariosChange){if(window._riskTimer)clearTimeout(window._riskTimer);window._riskTimer=setTimeout(()=>onScenariosChange({...scenarios,__riskPct:v,__stock:stock}),800);}}}
              style={{width:60,background:'rgba(0,0,0,0.3)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:6,color:'#fff',fontSize:13,fontWeight:700,padding:'4px 8px',outline:'none'}}/>
            <div style={{fontSize:9,color:'rgba(200,215,235,0.4)'}}>%</div>
          </div>
        </div>
      )}
    </div>
  );
}


// ═══ БЛОК КЛЮЧЕВЫХ СЛОВ ═══
function KeywordsBlock({ plan, onSave }) {
  const saved = plan.keywords_data || [];
  const empty = { keyword:'', cluster:'', freq_peak:'', freq_start:'', freq_end:'', date_peak:'', date_start:'', date_end:'' };
  const [keywords, setKeywords] = useState(saved.length ? saved : [{ ...empty, id: Date.now() }]);

  const addKw = () => {
    if (keywords.length >= 10) return;
    setKeywords(prev => [...prev, { ...empty, id: Date.now() }]);
  };

  const removeKw = (id) => setKeywords(prev => prev.filter(k => k.id !== id));

  const updateKw = (id, field, val) => {
    setKeywords(prev => {
      const next = prev.map(k => k.id === id ? { ...k, [field]: val } : k);
      if (window._kwSaveTimer) clearTimeout(window._kwSaveTimer);
      window._kwSaveTimer = setTimeout(() => onSave(next), 800);
      return next;
    });
  };

  const totalPeak  = keywords.reduce((s,k) => s + (Number(k.freq_peak)||0), 0);
  const totalStart = keywords.reduce((s,k) => s + (Number(k.freq_start)||0), 0);
  const totalEnd   = keywords.reduce((s,k) => s + (Number(k.freq_end)||0), 0);

  const inp = (w) => ({ background:'rgba(0,0,0,0.3)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:6, color:'#fff', fontSize:11, padding:'5px 8px', outline:'none', width:w||'100%', boxSizing:'border-box' });

  return (
    <div style={{marginTop:16, background:'#0a0f1a', border:'1px solid rgba(255,255,255,0.12)', borderRadius:12, padding:20}}>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16}}>
        <div style={{fontSize:13, fontWeight:700, color:'#8b5cf6'}}>🔑 Ключевые слова</div>
        {keywords.length < 10 && (
          <button onClick={addKw} style={{background:'rgba(139,92,246,0.15)', border:'1px solid rgba(139,92,246,0.3)', color:'#a78bfa', fontSize:11, padding:'5px 14px', borderRadius:7, cursor:'pointer'}}>
            + Добавить ключ
          </button>
        )}
      </div>

      {/* Шапка */}
      <div style={{display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 30px', gap:6, marginBottom:8, padding:'0 4px'}}>
        {['Ключевое слово','Кластер','Частота в пик','Дата пика','Частота нач. роста','Дата нач. роста','Частота кон. роста','Дата кон. роста',''].map((h,i) => (
          <div key={i} style={{fontSize:9, color:'rgba(200,215,235,0.4)', textAlign: i===0?'left':'center'}}>{h}</div>
        ))}
      </div>

      {/* Строки ключей */}
      {keywords.map(k => (
        <div key={k.id} style={{display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 30px', gap:6, marginBottom:6, alignItems:'center'}}>
          <input value={k.keyword} onChange={e=>updateKw(k.id,'keyword',e.target.value)} placeholder="кроссовки осенние женские" style={inp()}/>
          <input value={k.cluster} onChange={e=>updateKw(k.id,'cluster',e.target.value)} placeholder="осень" style={inp()}/>
          <input type="number" value={k.freq_peak} onChange={e=>updateKw(k.id,'freq_peak',e.target.value)} placeholder="10000" style={inp()}/>
          <input type="date" value={k.date_peak} onChange={e=>updateKw(k.id,'date_peak',e.target.value)} style={inp()}/>
          <input type="number" value={k.freq_start} onChange={e=>updateKw(k.id,'freq_start',e.target.value)} placeholder="5000" style={inp()}/>
          <input type="date" value={k.date_start} onChange={e=>updateKw(k.id,'date_start',e.target.value)} style={inp()}/>
          <input type="number" value={k.freq_end} onChange={e=>updateKw(k.id,'freq_end',e.target.value)} placeholder="3000" style={inp()}/>
          <input type="date" value={k.date_end} onChange={e=>updateKw(k.id,'date_end',e.target.value)} style={inp()}/>
          <button onClick={()=>removeKw(k.id)} style={{background:'none', border:'none', color:'rgba(239,68,68,0.4)', cursor:'pointer', fontSize:14, padding:0}}>✕</button>
        </div>
      ))}

      {/* Итого */}
      <div style={{display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 30px', gap:6, marginTop:12, padding:'10px 4px', borderTop:'1px solid rgba(255,255,255,0.08)'}}>
        <div style={{fontSize:11, fontWeight:700, color:'rgba(200,215,235,0.7)'}}>Общая частота (SAM)</div>
        <div/>
        <div style={{textAlign:'center', fontSize:13, fontWeight:700, color:'#8b5cf6'}}>{totalPeak.toLocaleString('ru-RU')}</div>
        <div/>
        <div style={{textAlign:'center', fontSize:13, fontWeight:700, color:'#60a5fa'}}>{totalStart.toLocaleString('ru-RU')}</div>
        <div/>
        <div style={{textAlign:'center', fontSize:13, fontWeight:700, color:'#10b981'}}>{totalEnd.toLocaleString('ru-RU')}</div>
        <div/>
        <div/>
        <div/>
      </div>

      {/* Подписи итогов */}
      <div style={{display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 30px', gap:6, padding:'0 4px'}}>
        <div/>
        <div/>
        <div style={{textAlign:'center', fontSize:9, color:'rgba(200,215,235,0.3)'}}>пик</div>
        <div/>
        <div style={{textAlign:'center', fontSize:9, color:'rgba(200,215,235,0.3)'}}>нач. роста</div>
        <div/>
        <div style={{textAlign:'center', fontSize:9, color:'rgba(200,215,235,0.3)'}}>кон. роста</div>
        <div/><div/><div/>
      </div>
    </div>
  );
}


// ═══ БЛОК РАЗДАЧ ═══
function GiveawaysBlock({ plan, stopLoss, onSave }) {
  const saved = plan.giveaways_data || [];
  const emptyG = { id:Date.now(), date:'', qty:'', price_return:'', channel:'telegram', status:'plan' };
  const [giveaways, setGiveaways] = useState(saved.length ? saved : []);

  const addG = () => setGiveaways(prev => [...prev, { ...emptyG, id: Date.now() }]);
  const removeG = (id) => {
    setGiveaways(prev => {
      const next = prev.filter(g => g.id !== id);
      save(next);
      return next;
    });
  };

  const save = (list) => {
    if (onSave) {
      if (window._gwSaveTimer) clearTimeout(window._gwSaveTimer);
      window._gwSaveTimer = setTimeout(() => onSave(list), 800);
    }
  };

  const updateG = (id, field, val) => {
    setGiveaways(prev => {
      const next = prev.map(g => g.id === id ? { ...g, [field]: val } : g);
      save(next);
      return next;
    });
  };

  // Данные из юнитки
  const cells = plan.cells || {};
  const params = plan.params || {};
  const price = Number(cells['Цена до СПП|#0d1526']||0);
  const spp = Number(params.spp||28);
  const priceSpp = Math.round(price*(1-spp/100)*100)/100;
  const commission = Number(cells['Комиссия на 1 ед.|#1a0d0d']||params.commission||36);
  const cost = Number(cells['Себес.|#1a1208']||0);
  const ff = Number(cells['ФФ|#1a1208']||params.ff||100);
  const itogSeb = cost + ff;

  // Логистика
  const vol = cells['Объём (л)|#130f1a'];
  const volN = Number(vol)||0;
  const logBaseParam = Number(params.logBase||46);
  const logExtraParam = Number(params.logExtra||14);
  const calcLB = (v) => {
    if (!v||v<=0) return 0;
    const vn = Number(v);
    if (vn>1) return Math.round((logBaseParam+(vn-1)*logExtraParam)*10)/10;
    if (vn<=0.2) return 23; if (vn<=0.4) return 26; if (vn<=0.6) return 29; if (vn<=0.8) return 30;
    return 32;
  };
  const logBase = Number(cells['Логистика база|#130f1a']||calcLB(vol)||0);
  const il = Number(params.coef1||1.04);
  const koef = Number(params.coefSklad||1.45);
  const irp = price>0 ? Math.round(params.irp*price/100*100)/100 : 0;
  const deliv = logBase*koef*il+irp;

  const calcWave = (g) => {
    const qty = Number(g.qty)||0;
    const priceReturn = Number(g.price_return)||0;
    if (!qty) return null;
    // Выкуп раздачи считаем как 100% (покупатель специально берёт)
    const priceGiveaway = priceReturn > 0 ? Number(priceReturn) : 0;
    const minusPerUnit = -Math.round((priceSpp - priceGiveaway)*100)/100;
    const minusTotal = Math.round(minusPerUnit*qty*100)/100;
    return { qty, priceReturn: priceGiveaway, minusPerUnit, minusTotal };
  };

  const totalMinus = giveaways.reduce((s,g) => {
    const r = calcWave(g);
    return s + (r ? Math.abs(r.minusTotal) : 0);
  }, 0);

  const overStopLoss = stopLoss > 0 && totalMinus > stopLoss;

  const fmt = (v,d=0) => v==null||isNaN(v)?'—':Number(v).toLocaleString('ru-RU',{maximumFractionDigits:d});
  const inp = (w) => ({ background:'rgba(0,0,0,0.3)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:6, color:'#fff', fontSize:11, padding:'5px 8px', outline:'none', width:w||'100%', boxSizing:'border-box' });

  return (
    <div style={{marginTop:16, background:'#0a0f1a', border:'1px solid rgba(255,255,255,0.12)', borderRadius:12, padding:20}}>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16}}>
        <div style={{fontSize:13, fontWeight:700, color:'#f59e0b'}}>📦 Раздачи (план)</div>
        <button onClick={addG} style={{background:'rgba(245,158,11,0.15)', border:'1px solid rgba(245,158,11,0.3)', color:'#f59e0b', fontSize:11, padding:'5px 14px', borderRadius:7, cursor:'pointer'}}>
          + Добавить волну
        </button>
      </div>

      {/* Шапка */}
      <div style={{display:'grid', gridTemplateColumns:'1fr 80px 120px 100px 100px 30px', gap:6, marginBottom:8, padding:'0 4px'}}>
        {['Дата','Штук','Цена для клиента','Минус/шт','Минус/волна',''].map((h,i) => (
          <div key={i} style={{fontSize:9, color:'rgba(200,215,235,0.4)', textAlign:i===0?'left':'center'}}>{h}</div>
        ))}
      </div>

      {giveaways.length === 0 && (
        <div style={{textAlign:'center', padding:24, color:'rgba(200,215,235,0.25)', fontSize:11}}>Добавьте волну раздач</div>
      )}

      {giveaways.map(g => {
        const r = calcWave(g);
        return (
          <div key={g.id} style={{display:'grid', gridTemplateColumns:'1fr 80px 120px 100px 100px 30px', gap:6, marginBottom:6, alignItems:'center',
            background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.05)', borderRadius:8, padding:'6px 4px'}}>
            <input type="date" value={g.date} onChange={e=>updateG(g.id,'date',e.target.value)} style={inp()}/>
            <input type="number" value={g.qty} onChange={e=>updateG(g.id,'qty',e.target.value)} placeholder="50" style={inp()}/>
            <input type="number" value={g.price_return||''} onChange={e=>updateG(g.id,'price_return',e.target.value)} placeholder={String(Math.round(priceSpp))} style={inp()}/>
            <div style={{textAlign:'center', fontSize:11, color:'#ef4444'}}>{r ? fmt(r.minusPerUnit)+' ₽' : '—'}</div>
            <div style={{textAlign:'center', fontSize:11, fontWeight:600, color:'#ef4444'}}>{r ? fmt(r.minusTotal)+' ₽' : '—'}</div>
            <button onClick={()=>removeG(g.id)} style={{background:'none', border:'none', color:'rgba(239,68,68,0.4)', cursor:'pointer', fontSize:14, padding:0}}>✕</button>
          </div>
        );
      })}

      {/* Итого */}
      {giveaways.length > 0 && (
        <div style={{marginTop:12, borderTop:'1px solid rgba(255,255,255,0.08)', paddingTop:12}}>
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <div style={{fontSize:12, color:'rgba(200,215,235,0.5)'}}>Итого минус на раздачи:</div>
            <div style={{fontSize:18, fontWeight:700, color:'#ef4444'}}>{fmt(totalMinus)} ₽</div>
          </div>
          {stopLoss > 0 && (
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:6}}>
              <div style={{fontSize:11, color:'rgba(200,215,235,0.4)'}}>Стоп-лосс:</div>
              <div style={{fontSize:13, fontWeight:600, color:'#f59e0b'}}>{fmt(stopLoss)} ₽</div>
            </div>
          )}
          {overStopLoss && (
            <div style={{marginTop:10, padding:'10px 14px', background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.35)', borderRadius:8, fontSize:11, color:'#ef4444', fontWeight:600}}>
              ⛔ Бюджет раздач {fmt(totalMinus)} ₽ превышает стоп-лосс {fmt(stopLoss)} ₽ на {fmt(totalMinus-stopLoss)} ₽. Сократи количество или цену раздач.
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ═══ ДЕТАЛЬНАЯ СТРАНИЦА ═══
function StrategyDetail({ id, onBack }) {
  const [data, setData] = useState(null);
  const [plan, setPlan] = useState({});
  const [unitStats, setUnitStats] = useState({ profitRK:null, profitNoRK:null, buyoutAvg:30 });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const autoSaveTimer = useState(null);

  const load = useCallback(async () => {
    try {
      const [r, up] = await Promise.all([
        api.get('/strategies/'+Number(id)),
        api.get('/monitoring/unit-params').catch(()=>({ data:{} })),
      ]);
      setData(r.data);
      const unitP = up.data || {};
      const existingParams = r.data.plan?.params || {};
      // Мержим из юнитки: ff, stdMargin, coef1, irp, turnover, tax, coefSklad, logBase, logExtra, storageBase, storageExtra
      // НЕ берём: spp, drr, commission
      const mergedParams = {
        ...existingParams,
        ...(unitP.ff        != null ? { ff:        unitP.ff }        : {}),
        ...(unitP.stdMargin != null ? { stdMargin: unitP.stdMargin } : {}),
        ...(unitP.coef1     != null ? { coef1:     unitP.coef1 }     : {}),
        ...(unitP.irp       != null ? { irp:       unitP.irp }       : {}),
        ...(unitP.turnover  != null ? { turnover:  unitP.turnover }   : {}),
        ...(unitP.tax       != null ? { tax:       unitP.tax }       : {}),
        ...(unitP.coefSklad != null ? { coefSklad: unitP.coefSklad } : {}),
        ...(unitP.logBase   != null ? { logBase:   unitP.logBase }   : {}),
        ...(unitP.logExtra  != null ? { logExtra:  unitP.logExtra }  : {}),
        ...(unitP.storageBase  != null ? { storageBase:  unitP.storageBase }  : {}),
        ...(unitP.storageExtra != null ? { storageExtra: unitP.storageExtra } : {}),
      };
      setPlan({ ...(r.data.plan || {}), params: mergedParams });
    } catch(e) { console.error(e); }
    setLoading(false);
  }, [id]);

  useEffect(()=>{load();},[load]);

  const savePlan = async (planData, dataObj) => {
    setSaving(true);
    try {
      await api.put('/strategies/'+id+'/plan', {
        ...(planData||plan),
        name: (dataObj||data).name,
        season_days: (dataObj||data).season_days,
        season_start: (dataObj||data).season_start,
      });
    } catch(e) {}
    setSaving(false);
  };

  const handlePlanChange = (newPlan) => {
    setPlan(newPlan);
    if (autoSaveTimer[0]) clearTimeout(autoSaveTimer[0]);
    autoSaveTimer[0] = setTimeout(() => savePlan(newPlan, data), 1000);
  };

  if (loading) return <div style={{minHeight:'100vh',background:'#0a0f1a',color:'rgba(200,215,235,0.4)',padding:24,display:'flex',alignItems:'center',justifyContent:'center'}}>Загружаем...</div>;
  if (!data)   return <div style={{minHeight:'100vh',background:'#0a0f1a',color:'#fff',padding:24}}>Не найдено</div>;

  const inp = {background:'rgba(0,0,0,0.3)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:7,color:'#fff',fontSize:12,padding:'6px 8px',outline:'none',width:'100%',boxSizing:'border-box'};

  return (
    <div style={{minHeight:'100vh',background:'#0a0f1a',color:'#fff'}}>

      {/* ШАПКА */}
      <div style={{padding:'14px 24px',borderBottom:'1px solid rgba(255,255,255,0.06)',display:'flex',alignItems:'center',gap:12,position:'sticky',top:0,zIndex:50,background:'rgba(10,15,26,0.95)',backdropFilter:'blur(10px)'}}>
        <button onClick={onBack} style={{background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',color:'rgba(200,215,235,0.7)',fontSize:12,padding:'5px 12px',borderRadius:7,cursor:'pointer'}}>← Назад</button>
        <div style={{flex:1}}>
          <div style={{fontSize:16,fontWeight:700}}>{data.name}</div>
          {data.vendor_code&&<div style={{fontSize:10,color:'rgba(200,215,235,0.4)'}}>{data.vendor_code} · <span className="blur-nmid">{data.nm_id}</span> · сезон {data.season_days} дн</div>}
        </div>
      </div>

      <div style={{padding:24}}>

        {/* ПАРАМЕТРЫ СЕЗОНА */}
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:10,marginBottom:16,alignItems:'end'}}>
          <div>
            <div style={{fontSize:10,color:'rgba(200,215,235,0.5)',marginBottom:4}}>Название стратегии</div>
            <input value={data.name} onChange={e=>{const v=e.target.value;setData(d=>({...d,name:v}));if(autoSaveTimer[0])clearTimeout(autoSaveTimer[0]);autoSaveTimer[0]=setTimeout(()=>savePlan(plan,{...data,name:v}),1000);}} style={inp}/>
          </div>
          <div>
            <div style={{fontSize:10,color:'rgba(200,215,235,0.5)',marginBottom:4}}>Начало сезона</div>
            <input type="date" value={data.season_start?.split('T')[0]||''} onChange={e=>{const v=e.target.value;setData(d=>({...d,season_start:v}));if(autoSaveTimer[0])clearTimeout(autoSaveTimer[0]);autoSaveTimer[0]=setTimeout(()=>savePlan(plan,{...data,season_start:v}),1000);}} style={inp}/>
          </div>
          <div>
            <div style={{fontSize:10,color:'rgba(200,215,235,0.5)',marginBottom:4}}>Длина сезона, дней</div>
            <input type="number" value={data.season_days||''} onChange={e=>{const v=Number(e.target.value);setData(d=>({...d,season_days:v}));if(autoSaveTimer[0])clearTimeout(autoSaveTimer[0]);autoSaveTimer[0]=setTimeout(()=>savePlan(plan,{...data,season_days:v}),1000);}} style={inp}/>
          </div>
        </div>

        {/* ЮНИТКА */}
        <StrategyUnitTable plan={plan} onChange={handlePlanChange} stdMargin={18} seasonDays={data.season_days} seasonStart={data.season_start} unitStats={unitStats}/>
        <StrategyFactTable plan={plan} onChange={handlePlanChange} onStatsChange={setUnitStats}/>
        <SeasonStats
          strategyId={id}
          nmId={plan.cells?.__factNmId}
          seasonStart={data.season_start?.split('T')[0]}
          seasonDays={data.season_days}
          profitRK={unitStats.profitRK}
          profitNoRK={unitStats.profitNoRK}
          buyoutAvg={unitStats.buyoutAvg}
          price={unitStats.price}
          drr={unitStats.drr}
        />

      </div>
    </div>
  );
}

// ═══ ГЛАВНЫЙ КОМПОНЕНТ ═══
export default function Strategy() {
  const [strategies, setStrategies] = useState([]);
  const [articles, setArticles]     = useState([]);
  const [loading, setLoading]       = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [openId, setOpenId] = useState(()=>{ const h = window.location.hash.replace('#strategy-',''); return h ? Number(h) : null; });

  const openStrategy = (id) => { window.location.hash = 'strategy-'+id; setOpenId(Number(id)); };
  const closeStrategy = () => { window.location.hash = ''; setOpenId(null); };

  useEffect(()=>{
    Promise.all([api.get('/strategies'),api.get('/strategies/unit/articles')])
      .then(([sr,ar])=>{setStrategies(sr.data||[]);setArticles(ar.data||[]);})
      .catch(()=>{}).finally(()=>setLoading(false));
  },[]);

  const handleCreated = (s) => { setStrategies(prev=>[s,...prev]); setShowCreate(false); openStrategy(s.id); };
  const handleDelete  = async (id) => { if(!window.confirm('Удалить стратегию?'))return; await api.delete('/strategies/'+id); setStrategies(prev=>prev.filter(s=>s.id!==id)); };

  if (openId) return <StrategyDetail id={openId} onBack={closeStrategy}/>;

  return (
    <div style={{minHeight:'100vh',background:'#0a0f1a',color:'#fff',padding:24}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
        <div>
          <h1 style={{fontSize:20,fontWeight:700,marginBottom:4}}>◎ Стратегия</h1>
          <div style={{fontSize:12,color:'rgba(200,215,235,0.4)'}}>Планируй раздачи и считай окупаемость до запуска</div>
        </div>
        <button onClick={()=>setShowCreate(true)} style={{background:'rgba(59,130,246,0.2)',border:'1px solid rgba(59,130,246,0.4)',color:'#60a5fa',fontSize:13,padding:'9px 18px',borderRadius:8,cursor:'pointer',fontWeight:700}}>
          + Новая стратегия
        </button>
      </div>
      {loading ? <div style={{color:'rgba(200,215,235,0.4)'}}>Загружаем...</div> : (
        <StrategyList strategies={strategies} onOpen={id=>openStrategy(id)} onDelete={handleDelete} onNew={()=>setShowCreate(true)}/>
      )}
      {showCreate&&<CreateModal articles={articles} onCreated={handleCreated} onCancel={()=>setShowCreate(false)}/>}
    </div>
  );
}
